<template>
  <div>
    <div class="right-title">
      <span>一般双选会列表</span>
      <router-link to="/home/meetAdmin/meetAdd">
        <el-button type="primary">创建一般双选会</el-button>
      </router-link>
    </div>
    <div class="content-box">
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',
    color: '#000;'}"
        >
          <el-table-column
            prop="id"
            label="ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="双选会名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
            align="center"
          >
          </el-table-column>

          <el-table-column
            label="报名状态"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="swBox" style="position: relative;">
                <el-switch
                  v-model="scope.row.is_form_apply"
                  active-color="#bababa"
                  inactive-color="#00a2ea"
                >
                </el-switch>
                <div class="swShade" @click="baomingState(scope.row.id)"
                     style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="修改"
            align="center"
          >
            <template slot-scope="scope">
              <span class="hal-cursor hals-color" @click="toEdit(scope.row.id)">修改</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="查看报名列表"
            align="center"
          >toDetail
            <template slot-scope="scope">
              <span class="hal-cursor hals-color" @click="toDetail(scope.row.id,scope.row.name)">查看报名列表</span>
            </template>
          </el-table-column>
          <el-table-column
            label="手机端报名地址"
            align="center"
          >
            <template slot-scope="scope">
              <span class="hal-cursor hals-color" @click="toCopy(scope.row.id,1)">复制</span>
            </template>
          </el-table-column>
          <el-table-column
            label="PC端双选会地址"
            align="center"
          >
            <template slot-scope="scope">
              <span class="hal-cursor hals-color" @click="toCopy(scope.row.id,2)">复制</span>
            </template>
          </el-table-column>
          <el-table-column
            label="手机端双选会地址"
            align="center"
          >
            <template slot-scope="scope">
              <span class="hal-cursor hals-color" @click="toCopy(scope.row.id,3)">复制</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <span class="hal-cursor hals-color" @click="toClose(scope.row.id)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <div>
            共计{{page.pageTotal}}条
          </div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    data() {
      return {
        tableData: [],
        multipleSelection: [], //  选中的
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        },
      }
    },
    computed: {
      list() {
        let _list = JSON.parse(JSON.stringify(this.tableData))
        return _list
      },
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 0)
      this.sxhList()
    },
    methods: {
      //  删除双选会
      toClose(id) {
        this.$confirm('您确定要删除这条双选会信息吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.delCustomSXH({
            sxhId: id,
            adminId: this.user.id,
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.sxhList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {

        });
      },
      // 双选会列表
      sxhList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }

        this.$api.apiContent.listCustomSXH({
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
          adminId: this.user.id,
        }).then(res => {
          loading.close();

          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          this.tableData = res.data
          this.tableData.map(item => {
            item.create_time = this.$tools.ZHDate(new Date(item.create_time * 1000), 3)
            item.is_form_apply = item.is_form_apply === 0 ? (true) : (false)
          })

        }).catch(() => {
          loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      //  列表选中存入数据
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/meetAdmin/meetList',
          query: {
            pageNum: this.page.pageNum
          }
        })
      },
      //  报名状态
      baomingState(id) {
        let state = ""
        this.tableData.map(item => {
          if (item.id === id) {
            state = item.is_form_apply
          }
        })
        let messg = ""
        if (!state) {
          messg = "此操作将设置不能报名, 是否继续?"
        } else {
          messg = "此操作将打开报名, 是否继续?"
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.setSXHApplyForm({
            sxhId: id,
            adminId: this.user.id,
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.sxhList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {

        });
      },


      //  修改
      toEdit(id) {
        this.$router.push('/home/meetAdmin/meetEdit?id=' + id)
      },
      //  查看报名表
      toDetail(id, name) {
        this.$router.push('/home/meetAdmin/meetDetail?id=' + id + '&name=' + name)
      },
      //  复制
      toCopy(id, type) {
        if (type === 1) {
          let clipBoardContent = 'https://phone.zexian.org.cn/zhuantiForm?id=' + id
          // let clipBoardContent = 'https://ttphone.zexian.org.cn/zhuantiForm?id=' + id
          let oInput = document.createElement('input')
          oInput.value = clipBoardContent
          document.body.appendChild(oInput)
          oInput.select() // 选择对象
          document.execCommand("Copy") // 执行浏览器复制命令
          this.$message.success('复制链接成功')
        } else if (type === 2) {
          let clipBoardContent = 'https://zexian.org.cn/zhuantiList2?id=' + id
          // let clipBoardContent = 'https://ttpc.zexian.org.cn/zhuantiList2?id=' + id
          let oInput = document.createElement('input')
          oInput.value = clipBoardContent
          document.body.appendChild(oInput)
          oInput.select() // 选择对象
          document.execCommand("Copy") // 执行浏览器复制命令
          this.$message.success('复制链接成功')
        } else if (type === 3) {
          let clipBoardContent = 'https://phone.zexian.org.cn/zhuantiList2?id=' + id
          // let clipBoardContent = 'https://ttphone.zexian.org.cn/zhuantiList2?id=' + id
          let oInput = document.createElement('input')
          oInput.value = clipBoardContent
          document.body.appendChild(oInput)
          oInput.select() // 选择对象
          document.execCommand("Copy") // 执行浏览器复制命令
          this.$message.success('复制链接成功')
        }
      }
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.sxhList()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
.right-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;

    .search {
      width: 220px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

</style>